import { format as f, isValid } from "date-fns";

interface FormatDateOptions {
    format?: string;
}

export const formatDate = (date:any, opts?:FormatDateOptions) => {
    const { format = 'dd-MM-yyyy' } = opts || {};

    switch (typeof date) {
        case 'string':
            return f(new Date(date), format);
        case 'number':
            return f(new Date(date), format);
        case 'object':
            return f(date, format);
        default:
            return '';
    }
}


export const isValidDate = (date?:string |  Date):boolean => {
    if(!date) return false;  
    const d = new Date(date);
    if(isValid(d)) {
        return true
    } else {
        return false
    }
}

export const convertToDate = (date?:string | Date | null):Date | undefined => {
    if(!date) return undefined;
    const isValid = isValidDate(date)
    if(!isValid) return undefined;
    
    const d = new Date(date)
    return d
}